import type { Tomo } from '../types/content'

export const tomos: Tomo[] = [
  {
    numero: '01',
    emoji: '⏱️',
    nombre: 'El Cronómetro de Oro',
    descripcion:
      'Dominá tus tiempos y terminá con las jornadas eternas. Incluye protocolos de limpieza express y cálculo de tiempos reales para maximizar tu agenda sin agotarte.',
    meta: 'Checklists de velocidad incluidos',
    imagen:
      'https://cdn.magicpatterns.com/uploads/tXsJBkijqi7gDiFzb3c43V/heylloyd-image-1789703456386_1_tomo.png',
  },
  {
    numero: '02',
    emoji: '💵',
    nombre: 'El Menú de Diseños “Cash”',
    descripcion:
      'Cobrá más por el mismo tiempo de trabajo. Catálogo de diseños de alta rotación (los que más piden y menos tiempo llevan). Incluye la Matriz de Precios por complejidad y el script exacto para rechazar diseños imposibles sin perder a la clienta.',
    meta: 'Diseños listos incluidos',
    imagen:
      'https://cdn.magicpatterns.com/uploads/qzismu5Vr4Hr5HogQEuAtb/heylloyd-image-1789704656011_TOMO_2.png',
  },
  {
    numero: '03',
    emoji: '🧘‍♀️',
    nombre: 'El Escudo Anti-Reclamos',
    descripcion:
      'Protegé tu paz y tu bolsillo. Fichas médicas, contratos de servicio y política de retoques. Poné límites claros de horario y cobrá cada extra sin entrar en conflicto.',
    meta: 'Fichas y contratos incluidos',
    imagen:
      'https://cdn.magicpatterns.com/uploads/orNmJBqnrRZce5vzVaPWwi/heylloyd-image-1789703044632_tomo_4.png',
  },
  {
    numero: '04',
    emoji: '📈',
    nombre: 'La Máquina de Ganancia Real',
    descripcion:
      'Dejá de trabajar a pérdida. Calculá en 10 minutos tu costo por servicio y tu ganancia neta por hora. Incluye el guion exacto para actualizar tus tarifas con autoridad y seguridad.',
    meta: 'Matriz de precios LATAM incluida',
    imagen:
      'https://cdn.magicpatterns.com/uploads/pUiHTuJ5HXRqTRvwRaSpWY/heylloyd-image-1789704187537_tomo_2_maquina.png',
  },
  {
    numero: '05',
    emoji: '💎',
    nombre: 'Imán de Clientas Premium',
    descripcion:
      'Atraé al público que sí paga lo que valés. 30 días de contenido listo para publicar y el paso a paso para convertir seguidoras en citas confirmadas, sin perseguir a nadie.',
    meta: 'Contenido listo para copiar',
    imagen:
      'https://cdn.magicpatterns.com/uploads/rKFSJdgvRR8aMZum5MRkMc/heylloyd-image-1789703215189_tomo_5.png',
  },
  {
    numero: '06',
    emoji: '🧰',
    nombre: 'El Botiquín de Crisis',
    descripcion:
      'Diagnóstico rápido de problemas técnicos, manejo de roturas y reacciones, recuperación de una clienta molesta y protocolos de higiene y seguridad.',
    meta: 'Protocolos de higiene incluidos',
    imagen:
      'https://cdn.magicpatterns.com/uploads/32DmeUKpYV76wuVftuMTqi/heylloyd-image-1789703344441_tomo_6.png',
  },
]

export const incluyeCadaTomo: string[] = [
  'Guías prácticas listas para usar hoy',
  'Scripts y textos que funcionan',
  'Checklists de trabajo diario',
  'Matrices de precios adaptadas a tu país',
  'Protocolos profesionales documentados',
  'Respuestas para situaciones difíciles',
  'Lenguaje que funciona en toda LATAM',
  'Diseños, calendarios y recursos visuales',
]
